import { formatCurrency, renderYesNoResponse } from "helpers/formatData"
import { columns, getPropertyStatus } from "./data"

export const propertiesColumns = () => {
    return columns.map((col) => col.Header === 'actions' ? 'ID' : col.Header)
}

export const propertiesRows = (property) => {
    return {
        id: property?.id ?? 'NA',
        name: property?.name ?? 'NA',
        address: property?.address ?? 'NA',
        propertyType: property?.propertyType?.name ?? 'NA',
        propertyStatus: getPropertyStatus(property?.propertyStatus) ?? 'NA',
        propertyPrice: (property?.propertyPrice || property?.propertyPrice === 0) ?  formatCurrency(property?.propertyPrice) : 'NA',
        fundedPercentage: property?.fundedPercentage? `${property.fundedPercentage}%` : 'NA',
        totalShare: property?.totalShare ?? 'NA',
        amountInvested: (property?.amountInvested || property?.amountInvested === 0) ? formatCurrency(property?.amountInvested) : 'NA',
        lastDividendPerShare: (property?.lastDividendPerShare || property?.lastDividendPerShare === 0)? formatCurrency(property?.lastDividendPerShare) : 'NA',
        lastTradePrice: (property?.lastTradePrice || property?.lastTradePrice === 0) ? formatCurrency(property?.lastTradePrice) : 'NA',
        isRegD: renderYesNoResponse(property?.isRegD)
    }
}